import { useQuery,useMutation } from '@tanstack/react-query';
import { createOrder,fetchVanOrders,fetchOrderDetails,generateQrCode,fetchTodaysLoad,updateOrder,validateCouponCode } from './vanuser.api';

export const useCreateOrder = (options = {}) => {
  return useMutation({
    mutationFn: createOrder,
    ...options
  });
};

export const useOrders = ({ page, perPage }) => {
  return useQuery({
    queryKey: ['vanOrders', page, perPage],
    queryFn: () => fetchVanOrders({  page, perPage }),
    keepPreviousData: true,
  });
};
export const useOrderDetails = (orderid, enabled = true) => {
  return useQuery({
    queryKey: ['vanOrder', orderid],
    queryFn: () => fetchOrderDetails(orderid),
    enabled: !!orderid && enabled
  });
};
export const useGenerateQrCode = (orderId, enabled = true) => {
  return useQuery({
    queryKey: ['qrCode', orderId],
    queryFn: () => generateQrCode(orderId),
    enabled: !!orderId && enabled,
    select: (blob) => URL.createObjectURL(blob), // 👈 Converts Blob to image URL
  });
};

export const useFetchTodaysLoad = (options = {}) => {
  return useQuery({
    queryKey: ['todays-load'],
    queryFn: async() => {  
       const data = await fetchTodaysLoad();
      return data;},
      staleTime: 0,             // ⛔ data considered stale immediately
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      enabled: options.enabled ?? true,
    ...options
  });
};

export const useUpdateOrder = (options = {}) => {
  return useMutation({
    mutationFn: updateOrder,
    ...options
  });
};

export const useValidateCouponCode = (options = {}) => {
  return useMutation({
    mutationFn: ({ coupon_code, order_price }) =>
      validateCouponCode(coupon_code, order_price),
    ...options,
  });
};
